<template>
  <div class="main">
    <a-form :form="form" class="user-layout-login" ref="formLogin" id="formLogin">
      <a-tabs :activeKey="customActiveKey" :tabBarStyle="{ textAlign: 'center', borderBottom: 'unset' }"
        @change="handleTabClick">
        <a-tab-pane key="tab1" tab="账号密码登陆">
          <a-form-item>
            <a-input size="large" v-decorator="['username', { rules: validatorRules.username.rules }]" type="text"
              placeholder="请输入帐户名">
              <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-input v-decorator="['password', { rules: validatorRules.password.rules }]" size="large" type="password"
              autocomplete="false" placeholder="密码">
              <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-item>

        </a-tab-pane>
        <a-tab-pane key="tab2" tab="钉钉扫码登陆" id="dd_code" style="text-align: center">
        </a-tab-pane>
      </a-tabs>

      <a-form-item v-if="submitBtn">
        <a-checkbox v-decorator="['rememberMe', { initialValue: true, valuePropName: 'checked' }]">自动登陆</a-checkbox>
      </a-form-item>

      <a-form-item v-if="submitBtn" style="margin-top:24px">
        <a-button size="large" type="primary" htmlType="submit" class="login-button" :loading="loginBtn"
          @click.stop.prevent="handleSubmit" :disabled="loginBtn">登陆
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import api from '@/api'
import { mapActions } from 'vuex'
import { timeFix, getUrlQueryString } from '@/utils/util'
import Vue from 'vue'
import { ACCESS_TOKEN, ENCRYPTED_STRING } from '@/store/mutation-types'
import { putAction, postAction, getAction } from '@/api/manage'
import { encryption, getEncryptedString } from '@/utils/encryption/aesEncrypt'
import store from '@/store/'
import { USER_INFO } from '@/store/mutation-types'
import { ddScanLogin } from '@/api/login'


// const larkAuthUrl = 'https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=https://www.cnbook.online/user/larkLogin&app_id=cli_a261680eed1e100d';

var appId = null
var redirect_url = null
var goto = null
var handleMessage = function (event) {
  var origin = event.origin;
  if (origin == "https://login.dingtalk.com") { //判断是否来自ddLogin扫码事件。
    // 拿到 loginTmpCode 后，跳转连接拿到临时登陆码，之后返回到跳转的地址，会携带临时登陆码
    var loginTmpCode = event.data;
    let url = 'https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=' + appId + '&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=' + redirect_url + '&loginTmpCode=' + loginTmpCode;;
    window.location.href = url;
  }
};
if (typeof window.addEventListener != 'undefined') {
  window.addEventListener('message', handleMessage, false);
} else if (typeof window.attachEvent != 'undefined') {
  window.attachEvent('onmessage', handleMessage);
}

export default {
  data() {
    return {
      customActiveKey: 'tab2',
      loginBtn: false,
      loginType: 0,
      form: this.$form.createForm(this),
      encryptedString: {
        key: '',
        iv: '',
      },
      validatorRules: {
        username: { rules: [{ required: true, message: '请输入用户名!' }, { validator: this.handleUsernameOrEmail }] },
        password: { rules: [{ required: true, message: '请输入密码!', validator: 'click' }] },
      },
      currentUsername: '',
      validate_status: '',
      currdatetime: '',
      qywxinParam: {
        authCode: '',
        appId: '',
        agentId: ''
      },
      submitBtn: false
    }
  },
  created() {
    this.currdatetime = new Date().getTime()
    Vue.ls.remove(ACCESS_TOKEN)
    this.getRouterData()
    this.createDdingObj()
  },
  methods: {
    ...mapActions(['Login', 'Logout', 'PhoneLogin', 'ThirdLogin']),
    handleTabClick(key) {

      if (key == 'tab1') {
        this.submitBtn = true
      }
      if (key == 'tab2') {
        this.submitBtn = false
      }
      this.customActiveKey = key
    },
    createDdingObj() {
      let that = this
      getAction(`/sys/getDdingParams`).then(res => {
        if (res.success) {
          let result = res.result
          redirect_url = encodeURIComponent(result.redirect_url)
          appId = result.appId;
          goto = encodeURIComponent('https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=' + appId + '&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=' + redirect_url)

          var obj = DDLogin({
            id: "dd_code",
            goto: goto, //请参考注释里的方式
            style: "border:none;background-color:#FFFFFF;",
            width: "365",
            height: "400"
          });

        } else {
          this.$message.error(res.message)
          this.requestCodeSuccess = false
        }

      }).catch(() => {
        this.requestCodeSuccess = false
      })

    },
    handleSubmit() {
      let that = this
      let loginParams = {}
      that.loginBtn = true
      // 使用账户密码登陆
      if (that.customActiveKey === 'tab1') {
        that.form.validateFields(['username', 'password', 'rememberMe'], { force: true }, (err, values) => {
          if (!err) {
            loginParams.username = values.username
            // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
            //loginParams.password = md5(values.password)
            //loginParams.password = encryption(values.password,that.encryptedString.key,that.encryptedString.iv)
            loginParams.password = values.password
            loginParams.remember_me = values.rememberMe
            // update-begin- --- author:scott ------ date:20190805 ---- for:密码加密逻辑暂时注释掉，有点问题
            loginParams.checkKey = that.currdatetime
            that.Login(loginParams).then((res) => {
              if (res.success) {
                this.loginSuccess()
              } else {
                this.requestFailed(res)
                this.Logout()
              }
            }).catch((err) => {
              that.requestFailed(err)
            })
          } else {
            that.loginBtn = false
          }
        })
        // 使用手机号登陆
      } else {
        that.form.validateFields(['mobile', 'captcha', 'rememberMe'], { force: true }, (err, values) => {
          if (!err) {
            loginParams.mobile = values.mobile
            loginParams.captcha = values.captcha
            loginParams.remember_me = values.rememberMe
            that.PhoneLogin(loginParams).then((res) => {
              console.log(res.result)
              this.departConfirm(res)
            }).catch((err) => {
              that.requestFailed(err)
            })
          }
        })
      }
    },
    loginSuccess() {
      this.$router.push({ path: '/dashboard/analysis' })
      this.$notification.success({
        message: '欢迎',
        description: `${timeFix()}，欢迎回来`,
      })
    },
    cmsFailed(err) {
      this.$notification['error']({
        message: '登录失败',
        description: err,
        duration: 4,
      })
    },
    requestFailed(err) {
      this.$notification['error']({
        message: '登录失败',
        description: ((err.response || {}).data || {}).message || err.message || '请求出现错误，请稍后再试',
        duration: 4,
      })
      this.loginBtn = false
    },
    getRouterData() {
      this.$nextTick(() => {
        if (this.$route.params.username) {
          this.form.setFieldsValue({
            'username': this.$route.params.username
          })
        }
      })
    },
    //获取密码加密规则
    getEncrypte() {
      var encryptedString = Vue.ls.get(ENCRYPTED_STRING)
      if (encryptedString == null) {
        getEncryptedString().then((data) => {
          this.encryptedString = data
        })
      } else {
        this.encryptedString = encryptedString
      }
    },
  }
}
</script>

<style lang="less" scoped>
.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, .2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color .3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }

}
</style>
<style>
.valid-error .ant-select-selection__placeholder {
  color: #f5222d;
}
</style>